import { render } from "./PathGenerator.vue?vue&type=template&id=bc663f50&scoped=true"
import script from "./PathGenerator.vue?vue&type=script&lang=js"
export * from "./PathGenerator.vue?vue&type=script&lang=js"

import "./PathGenerator.vue?vue&type=style&index=0&id=bc663f50&scoped=true&lang=css"

import exportComponent from "/home/runner/work/vertex/vertex/webui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bc663f50"]])

export default __exports__